type Edges = Pick<DOMRect, 'left' | 'right'>;

const FADE_PX = 24;

// The browser clamps the result to the scrollable range.
const getRevealScrollLeft = (strip: Edges, tab: Edges, scrollLeft: number) => {
  if (tab.left < strip.left + FADE_PX) {
    return scrollLeft + tab.left - strip.left - FADE_PX;
  }
  if (tab.right > strip.right - FADE_PX) {
    return scrollLeft + tab.right - strip.right + FADE_PX;
  }
  return scrollLeft;
};

export { FADE_PX, getRevealScrollLeft };
